import { contact } from '../data/contact'

/** Loads Google Tag Manager once, only when a container ID is configured. */
export function loadGtm() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  const id = contact.gtmId.trim()
  if (!/^GTM-[A-Z0-9]+$/.test(id)) return
  if (document.getElementById('bciti-gtm')) return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })
  const s = document.createElement('script')
  s.id = 'bciti-gtm'
  s.async = true
  s.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`
  document.head.appendChild(s)
}
